// TODO: Animate them in like a qwipe / drawn on

(function ($) {
  function checkCoverRatios() {
    let coverContents = $(".cover-content");
    if (!coverContents.length) return;

    const ratioClasses = [
      "height-sm",
      "height-md",
      "height-lg",
      "height-xl",
      "height-xxl",
    ];

    coverContents.each(function () {
      let coverContent = $(this);
      let ratio = coverContent.outerHeight() / coverContent.outerWidth();

      let ratioClass;
      if (ratio > 2.0) ratioClass = "height-xxl";
      else if (ratio > 1.5) ratioClass = "height-xl";
      else if (ratio > 1.1) ratioClass = "height-lg";
      else if (ratio > 0.8) ratioClass = "height-md";
      else if (ratio > 0.6) ratioClass = "height-sm";
      else ratioClass = "height-xs";

      coverContent.removeClass(ratioClasses.join(" ")).addClass(ratioClass);
    });
  }

  $(window).on("load resize", checkCoverRatios);

  // Initialize on load
  document.addEventListener("DOMContentLoaded", function () {
    checkCoverRatios();
  });

  // Re-process all marks on window resize with debounce
  jfDebounce("resize", checkCoverRatios, 100);
})(jQuery);
